import {
  DragDropContext,
  Draggable,
  Droppable,
  DropResult,
} from '@hello-pangea/dnd';
import { Form, Formik } from 'formik';
import { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import DownItems from '../../../assets/Images/down-arrow.svg';
import DragItems from '../../../assets/Images/drag.svg';
import UpItems from '../../../assets/Images/up-arrow.svg';
import { MoveProcessEnum } from '../../../constants/enums';
import { MoveProcessList } from '../../../constants/type-constants';
import { IAddEditFormProps } from '../../../models/forms/IForm';
import FormLoader from '../../../shared-components/FormLoader/FormLoader';
import ModalFooter from '../../../shared-components/modal/modal-footer';
import { formatMessage } from '../../../translations/format-message';

interface IProps extends IAddEditFormProps<any> {
  operatorProcessOrder: any[];
}

const ReorderOperatorListDetailForm = (props: IProps) => {
  const [items, setItems] = useState<any[]>([]);

  useEffect(() => {
    setItems(
      props.operatorProcessOrder.map((option) => ({
        id: String(option.Id),
        name: option.ProcessName,
        shortName: option.ShortName,
        type: option.Type,
        IsHidden: option.Hide,
      }))
    );
  }, [props.operatorProcessOrder]);

  const handleDragEnd = (result: DropResult) => {
    if (!result.destination) return;

    const reordered = Array.from(items);
    const [removed] = reordered.splice(result.source.index, 1);
    reordered.splice(result.destination.index, 0, removed);

    setItems(reordered);
  };

  const moveItem = (index: number, direction: MoveProcessList) => {
    const newIndex = direction === MoveProcessEnum.Up ? index - 1 : index + 1;
    if (newIndex < 0 || newIndex >= items.length) return;

    const updated = [...items];
    const temp = updated[index];
    updated[index] = updated[newIndex];
    updated[newIndex] = temp;

    setItems(updated);
  };

  const handleHideToggle = (id: string) => {
    setItems((prev) =>
      prev.map((i) => (i.id === id ? { ...i, IsHidden: !i.IsHidden } : i))
    );
  };

  return (
    <>
      <Formik
        initialValues={props.initialValues}
        enableReinitialize
        validateOnBlur={false}
        onSubmit={async (_: any) => {
          props.submitHandler(items);
        }}
      >
        {({ setFieldValue }) => {
          return (
            <Form className="user-form">
              {props.isLoading ? (
                <FormLoader loading={props.isLoading} />
              ) : null}
              <Modal.Body>
                <DragDropContext onDragEnd={handleDragEnd}>
                  <Droppable droppableId="grid">
                    {(provided) => (
                      <div className="order-column">
                        <table
                          {...provided.droppableProps}
                          ref={provided.innerRef}
                          className="min-w-full table-auto border border-gray-300 w-100"
                        >
                          <thead>
                            <tr className="bg-gray-200">
                              {/* Do not remove They are in use */}
                              <th className="border px-4 py-2 text-center w-16">
                                <span className="ms-1">
                                  {formatMessage('hide_column')}
                                </span>
                              </th>
                              <th className="border px-4 py-2 show-Elipses">
                                {formatMessage('name')}
                              </th>
                              <th className="border px-4 py-2">
                                {formatMessage('short_name')}
                              </th>
                              <th className="border px-4 py-2">
                                {' '}
                                {formatMessage('process_type')}
                              </th>
                              <th className="border px-4 py-2">
                                {' '}
                                {formatMessage('actions')}
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {items.map((item, index) => (
                              (item.id> 0 &&
                              <Draggable
                                key={item.id}
                                draggableId={item.id}
                                index={index}
                              >
                                {(provided) => (
                                  <tr
                                    ref={provided.innerRef}
                                    {...provided.draggableProps}
                                    {...provided.dragHandleProps}
                                    className="border-b"
                                  >
                                    {/* Do not remove They are in use */}
                                    <td
                                      className="border px-4 py-2 text-center"
                                      onClick={(e) => e.stopPropagation()} // keep checkbox from starting a drag
                                    >
                                      <input
                                        // name="IsHidden"
                                        type="checkbox"
                                        className="form-check-input"
                                        checked={item.IsHidden}
                                        onChange={() =>
                                          handleHideToggle(item.id)
                                        }
                                        aria-label={`Hide ${item.name}`}
                                      />
                                    </td>
                                    <td className="border px-4 py-2 task-order show-Elipses">
                                      <img
                                        src={DragItems}
                                        alt=""
                                        className="drag me-2"
                                      />{' '}
                                      {item.name}
                                    </td>
                                    <td className="border px-4 py-2">
                                      {item.shortName}
                                    </td>
                                    <td className="border px-4 py-2">
                                      {formatMessage(item.type)}
                                    </td>
                                    <td className="border px-4 py-2 space-x-2 bg-red-100 up-down-items last-column">
                                      <div className="d-flex">
                                        <button
                                          type="button"
                                          onClick={() =>
                                            moveItem(index, MoveProcessEnum.Up)
                                          }
                                          disabled={index === 0}
                                          className={`px-2 py-1 bg-green-600 rounded btn-light-primary btn-sm ${index === 0 && 'disabled-li'}`}
                                        >
                                          <img
                                            src={UpItems}
                                            alt=""
                                            className="drag"
                                          />
                                        </button>
                                        <button
                                          type="button"
                                          onClick={() =>
                                            moveItem(
                                              index,
                                              MoveProcessEnum.Down
                                            )
                                          }
                                          disabled={index === items.length - 1}
                                          className={`px-2 py-1 bg-green-600 rounded btn-light-danger btn-sm ${index === items.length - 1 && 'disabled-li'}`}
                                        >
                                          <img
                                            src={DownItems}
                                            alt=""
                                            className="drag"
                                          />
                                        </button>
                                      </div>
                                    </td>
                                  </tr>
                                )}
                              </Draggable>
                            )))}
                            {provided.placeholder}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </Droppable>
                </DragDropContext>
              </Modal.Body>
              <ModalFooter
                id={props.id}
                onModalClosed={props.onModalClosed}
                isLoading={props.isLoading}
                saveNextBtn={'save'}
                backCancelBtn="cancel"
              />
            </Form>
          );
        }}
      </Formik>
    </>
  );
};

export default ReorderOperatorListDetailForm;
